import React from "react";
import { Box } from "@mui/material";
import PricingPlan from "src/components/pages/PricingPlans";

const PricingPlanPage = () => {
  return (
    <Box>
      <PricingPlan />
    </Box>
  );
};

export default PricingPlanPage;
